import React, { useState } from 'react'
import { Row, Col } from "antd"
import { useMediaQuery } from "react-responsive"
import businessImg from "images/shippy/business.svg"
import phoneImg from "images/shippy/phone.svg"
import mailImg from "images/shippy/mail.svg"
import BusinessForm from "../business_pages/components/BusinessForm"
import SuccessModal from "../business_pages/components/SuccessModal"

const SolutionSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [isFormModalVisible, setIsFormModalVisible] = useState(false)
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false)

  return (
    <>
      <Row
        // gutter={{ lg: 16 }}
        align="middle"
        style={{
          marginTop: isMobileScreen ? "10px" : "30px",
          padding: isMobileScreen ? "15px" : "",
          marginBottom: "-150px"
        }}
      >
        <Col span={24} order={2} md={{ order: 1, span: 12 }} xl={{ span: 8, offset: 4 }}>
          <img src={businessImg} />
        </Col>
        <Col span={24} order={1} md={{ order: 2, span: 12 }} xl={{ span: 9 }}>
          <div
            className="section-title about-title"
            style={{
              fontSize: "33px",
              letterSpacing: "1px",
            }}
          >
            {"Turi EBAY parduotuvę?"}
          </div>
          <div
            className="section-title about-title"
            style={{
              fontSize: "28px",
              fontWeight: "400",
              letterSpacing: "1px",
              fontFamily: "Trenda-regular",
            }}
          >
            {"Išbandyk Alsendo integraciją ir perkelk savo verslą į kitą lygį."}
          </div>
          <div className="section-buttons">
            <button
              className="btn btn-primary-alsendo btn-lg btn-circle"
              onClick={() => {
                setIsFormModalVisible(true)
              }}
            >
              {"Gauti pasiūlymą"}
            </button>
          </div>
          <div
            className="solution-contacts"
            style={{
              display: isMobileScreen ? "block" : "flex",
              marginTop: isMobileScreen ? "10px" : "25px"
            }}
          >
            <div
              className="solution-contacts-mail"
              style={{
                marginRight: "30px",
                width: isMobileScreen ? "100%" : "auto",
                display: "flex",
              }}
            >
              <img src={mailImg} style={{
                marginRight: "10px"
              }} />
              <div className="info-font nice-select">
                <a href="mailto: pardavimai@alsendo.lt">
                  {"pardavimai@alsendo.lt"}
                </a>
              </div>
            </div>
            <div
              className="solution-contacts-phone"
              style={{
                width: isMobileScreen ? "100%" : "auto",
                marginTop: isMobileScreen ? "15px" : "",
                display: "flex",
              }}
            >
              <img src={phoneImg} style={{
                marginRight: "10px",
              }} />
              <div
                className="nice-select info-font"
              >
                <a href="tel:+37065828980" style={{
                  color: "#2D3948"
                }}>
                  +370 658 28980
                </a>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {isFormModalVisible && (
        <BusinessForm
          setIsFormModalVisible={setIsFormModalVisible}
          setIsSuccessModalVisible={setIsSuccessModalVisible}
        />
      )}
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
    </>
  )
}

export default SolutionSection
